export default [
  'BOTHeroBannerCounter',
  'BOTBlackFridayContent'
]

/*
Appears on:
/black-friday
*/
